const {
  checkResponseStatusSuccess,
  checkResponseStatusCanceled,
  checkResponseStatusError,
} = require('../../util');
const { validateWsUrl } = require('../../security');
const BaseSocketService = require('./BaseSocketService');

/**
 * One-shot WebSocket client that awaits a terminal transaction status
 * (success / cancel / error) then closes. Used by 3DS and Click to Pay.
 */
class PaymentStatusSocketService {
  constructor(fieldsService = null) {
    this.fieldsService = fieldsService;
    this.callbacks = { onSuccess: null, onCancel: null, onError: null, onClose: null };
    this.base = new BaseSocketService({
      oneShot: true,
      reconnect: false,
      errorContext: 'payment_status_socket',
      onMessage: (response) => this._handleMessage(response),
      onClose: () => this._handleClose(),
      onError: (error) => this._handleError(error),
    });
  }

  connect(config) {
    this.setCallbacks(config.callbacks);
    return this.base.connect({
      wsUrl: config.wsUrl,
      referenceNumber: config.referenceNumber,
      merchantId: config.merchantId,
    });
  }

  setCallbacks(callbacks) {
    if (callbacks) {
      this.callbacks = { ...this.callbacks, ...callbacks };
    }
  }

  validateWsUrl(wsUrl) {
    return validateWsUrl(wsUrl);
  }

  _handleMessage(response) {
    if (checkResponseStatusSuccess(response)) {
      if (this.callbacks.onSuccess) this.callbacks.onSuccess(response);
    } else if (checkResponseStatusCanceled(response)) {
      if (this.callbacks.onCancel) this.callbacks.onCancel(response);
    } else if (checkResponseStatusError(response)) {
      if (this.callbacks.onError) this.callbacks.onError(response);
    } else if (this.callbacks.onError) {
      this.callbacks.onError({
        status: 'error',
        message: 'ws incorrect response',
        originalResponse: response,
      });
    }
    if (this.fieldsService) this.fieldsService.disableEnableFields(false);
    // base auto-closes (oneShot)
  }

  _handleClose() {
    if (this.callbacks.onClose) this.callbacks.onClose();
    if (this.fieldsService) this.fieldsService.disableEnableFields(false);
  }

  _handleError(error) {
    if (this.callbacks.onError) this.callbacks.onError(error);
  }

  close() {
    this.base.close();
  }

  getSocket() {
    return this.base.getSocket();
  }
}

module.exports = PaymentStatusSocketService;
